module.exports = __webpack_public_path__ + "static/media/logo_maewnam_menubar.fe30c1ad.png";